var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',_vm._g(_vm._b({class:[
    'indexer',
    'w-full',
    'lg:w-1/3',
    'xl:w-1/4',
    _vm.group === 'auth' ? 'notificationcenter' : 'lg:max-w-md',
  ],attrs:{"group":_vm.group,"duration":_vm.group === 'auth' ? 3000 : 5000},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('div',{class:['vue-notification w-full m-0 lg:m-1', props.item.type]},[_vm._v(" "+_vm._s(props.item.title)+" "),_c('div',{staticClass:"flex items-start w-full overflow-x-hidden"},[_c('div',{staticClass:"icon_wrapper"},[_c('BaseIcon',{staticClass:"text-lg",attrs:{"icon":_vm.icon(props.item.type)}})],1),_c('div',{staticClass:"notification_text",domProps:{"innerHTML":_vm._s(
            _vm.$t(`mygwf.components.Notification.${_vm.group}.${props.item.type}.${props.item.text}`)
          )}})]),_c('BaseIcon',{staticClass:"close_icon",attrs:{"icon":"close"},on:{"click":props.close}})],1)]}}])},'notifications',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }